export const appName = "oneul-site";

export const stage = "prod";
export const debug = false;
export const ec2Debug = false;

// export const debug = true;
// export const ec2Debug = true;
